import axiosapi from "./axiosAPI";

// Get All Users
export const getAllUsers = async (
      setIsLoading,
      setFirst,
      setRows,
      event,
      setUsers,
      setTotalCount,
      setFetcherror,
      searchTerm
) => {

    const page = ((event?.first)/(event?.rows))+1 || 1
    const limit = (event?.rows) || 10
    const search = searchTerm || ""

    
	try{
        const res = await axiosapi.get(`/users?page=${page}&limit=${limit}&search=${search}`);
        setUsers(res?.data?.data?.rows ? res?.data?.data?.rows : {});
        setTotalCount(res?.data?.data?.count);
        setIsLoading(false);
        setFirst(event? event?.first:0);
        setRows(event? event?.rows:10)
        

	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch Users");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Users");
		}
		
	}
	
};





// Get One User
export const getOneUser = async (
    pkid,
    setFetcherror,  
    setUser
    
)=>{
	try{
		const res =await axiosapi.get(`/users/${pkid}`);
        setUser(res.data.body);
       
	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch User");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch User");
		}
		
	}
	
};


// Create New User
export const createUser = async (
    firstname,
    setFirstname,
    lastname,
    setLastname,
    email,
    setEmail,
    password,
    setPassword,
    selectedRole,
    setSelectedRole,
    phone,
    setPhone,
    selectedSex,
    setSelectedSex,
    selectedRegion,
    setSelectedRegion,
    selectedDistrict,
    setSelectedDistrict,
    tin,
    setTin,
    setFetcherror,
    handleAllToasts,
    setUsers,
    setIsLoading,
    setFirst,
    setRows,
    event,
    setTotalCount,
    
) => {
    
    if (!firstname || !lastname || !password || !email || !selectedRole || !phone || !selectedSex || !selectedRegion || !selectedDistrict) {
        handleAllToasts(2, "Some User Details Missing");
            return; 
        }

    const role = selectedRole?.name;
    const region = selectedRegion?.name;
    const district = selectedDistrict?.name;
    const sex = selectedSex?.name;
    
    const PushItem = {
        firstname,
        lastname,
        email,
        password,
        phone,
        sex,
        role,
        region,
        district,
        tin
        };

    try{
        await axiosapi.post("/users/",PushItem );
        setFirstname("");
        setLastname("");
        setEmail("");
        setPassword("");
        setPhone("");
        setSelectedSex("");
        setSelectedRole("")
        setSelectedRegion("");
        setSelectedDistrict("");
        setTin("");
        
        handleAllToasts(1, "User Created Successfully");
        getAllUsers(
            setIsLoading,
            setFirst,
            setRows,
            undefined,
            setUsers,
            setTotalCount,
            setFetcherror
      )
    }
    catch(err){
        if(err.response){
            //Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Could Not Create New User");
            handleAllToasts(2, "Could Not update The User");
            
            
        }else{
            //No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Could Not Create New User");
            handleAllToasts(2, "Could Not update The User");
            
        }
        
    }
    
}


// Edit Existing User

export const editUser = async (
    userpkid,
    firstname,
    setFirstname,
    lastname,
    setLastname,
    selectedRole,
    setSelectedRole,
    phone,
    setPhone,
    selectedSex,
    setSelectedSex,
    selectedRegion,
    setSelectedRegion,
    selectedDistrict,
    setSelectedDistrict,
    tin,
    setTin,
    setFetcherror,
    handleAllToasts,
    setUsers,
    setIsLoading,
    setFirst,
    setRows,
    event,
    setTotalCount,

              
) => {
    

            if (!userpkid || !(firstname || !lastname || selectedRole || phone || selectedSex || selectedRegion || selectedDistrict)){
                handleAllToasts(2, "No User details to update")
                    return;  
                }

                const role = selectedRole?.name;
                const region = selectedRegion?.name;
                const district = selectedDistrict?.name;
                const sex = selectedSex?.name;
    

                const PushItem = {
                        id: userpkid,
                        firstname,
                        lastname,
                        phone,
                        sex,
                        role,
                        region,
                        district,
                        tin
                    }

            try{
                
                await axiosapi.patch("/users/", PushItem);
                setFirstname("");
                setLastname("");
                setPhone("");
                setSelectedSex("");
                setSelectedRole("")
                setSelectedRegion("");
                setSelectedDistrict("");
                setTin("");
                handleAllToasts(1, "User Updated Successfully");
                getAllUsers(
                    setIsLoading,
                    setFirst,
                    setRows,
                    undefined,
                    setUsers,
                    setTotalCount,
                    setFetcherror
              )

            }
            catch(err){
                if(err.response){
                    //Error Obtained from Backend not in 200
                    console.log(err.response.data);
                    console.log(err.response.status);
                    console.log(err.response.headers);
                    setFetcherror("Could Not Update User");
                    handleAllToasts(2, "Could Not Update User");
                    
                    
                }else{
                    //No response Obtained from the server.
                    console.log(`Error: ${err.message}`);
                    setFetcherror("Could Not Update User");
                    handleAllToasts(2, "Could Not Update User");
                    
                }
                
            }
            
};


// Block User
export const blockUser = async (
    userpkid,
    setUsers,
    setIsLoading,setFirst,setRows,setTotalCount,
    setFetcherror,
    handleAllToasts
) => {
    try {
        const res = await axiosapi.post(`/blockuser/${userpkid}`);
        let finalData = res.data.message;
        let userstatus = res.data.userstatus;
        getAllUsers(setIsLoading,setFirst,setRows,undefined,setUsers,setTotalCount,setFetcherror);
        handleAllToasts(1,  `${userstatus ? "Blocked" : "Ublocked"}`);
        
    }
    catch (err) {
        if (err.response) {
            //Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Delete User");
            handleAllToasts(2, "Error: Could Not Delete User");
			
        } else {
            //No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Delete User");
            handleAllToasts(2, "Error: Could Not Delete User");
        }
		
    }

}
// Block User
export const changePassword = async (
    userpkid,
    password,
    setPassord,
    setUsers,
    setIsLoading,setFirst,setRows,setTotalCount,
    setFetcherror,
    handleAllToasts
) => {
    try {

       const PushItem = {id:userpkid, password:password}
        const res = await axiosapi.post(`/changepassword`, PushItem);
        setPassord("");
        getAllUsers(setIsLoading,setFirst,setRows,undefined,setUsers,setTotalCount,setFetcherror);
        handleAllToasts(1,  `Password Changed Successfully`);
        
    }
    catch (err) {
        if (err.response) {
            //Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Delete User");
            handleAllToasts(2, "Error: Could Not Delete User");
			
        } else {
            //No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Delete User");
            handleAllToasts(2, "Error: Could Not Delete User");
        }
		
    }

}

// Delete Existing User.

export const deleteUser = async (
    userpkid,
    setUsers,
    setFetcherror,
    handleAllToasts,
    setIsLoading,
    setFirst,
    setRows,
    setTotalCount
)=>{
    try {
        const res = await axiosapi.delete(`/users/${userpkid}`);
        let finalData = res.data.message;
        getAllUsers(
            setIsLoading,
            setFirst,
            setRows,
            undefined,
            setUsers,
            setTotalCount,
            setFetcherror
      )
        handleAllToasts(1, "User Deleted Successfully");
        console.log("Deleted:", finalData);
    }
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
			console.log(err.response.data);
			console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Delete User");
            handleAllToasts(2,"Error: Could Not Delete User");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Delete User");
            handleAllToasts(2,"Error: Could Not Delete User");
		}
		
	}
	
};